var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.needsCheck && _vm.isExpired())?_c('CookieCheckContent'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }